/**
 * Agence'O - partners-slider.js
 * @author Guillaume Bouillon (Agence'O)
 * @created 21/05/2019
 */

(function ($) {

  if ($('.publications-slider').length) {
    // slider
    const pubSlider = new Swiper('.publications-slider', {
      speed: 400,
      spaceBetween: 100,
      navigation: {
        nextEl: '.js-next',
        prevEl: '.js-prev'
      },
      loop: true
    });
  }

}(jQuery));
